/* @minVersion 7.0.0-beta.0 */
/* @onlyBabel7 */

export default function _AwaitValue(value) {
  this.wrapped = value;
}
